exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".riskhub-logo[data-v-08bbc208]{width:100px;height:100px;margin-left:0;margin-top:0}.login-container[data-v-08bbc208]{position:relative;height:100%;min-height:580px;max-width:400px;padding:40px;background-color:#fff;border-radius:12px;border-top:1px solid #e9e9e9;-webkit-box-shadow:rgba(60,66,87,.12) 0 7px 14px 0,rgba(0,0,0,.12) 0 3px 6px 0;box-shadow:0 7px 14px 0 rgba(60,66,87,.12),0 3px 6px 0 rgba(0,0,0,.12);-webkit-transition:visibility 0s,opacity .5s linear;transition:visibility 0s,opacity .5s linear;visibility:visible;opacity:1;z-index:10;color:#1e212a}.login-header[data-v-08bbc208]{text-align:center}", ""]);

// exports
